import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';

import Bs4GenericField from './Bs4GenericField'
// import Bs4Stores from '../../Bs4Stores'
import * as Bs4Utils from '../../Bs4Components/Bs4Utils';
import { Button, alpha } from '@mui/material';
  
export default class Bs4Checkbox extends Bs4GenericField {
  
  canCloseCriteria = false;
  
  setValueBs4(value) {
    if (Bs4Utils.isString(value)) this.setValue(value.split(',').map(id => String(id).trim()));
    else if (Array.isArray(value)) this.setValue(value);
    else this.setValue([]);
    if (!Array.isArray(this.bs4Store)) this.bs4Store = [];    
  }

  isDifferentValues (oldValue, newVaue) {
    if (Array.isArray(oldValue) && Array.isArray(newVaue)) {
      if (oldValue.length != newVaue.length) return true;
      for (let i = 0; i < oldValue.length; i++) {
        if (oldValue[i] != newVaue[i]) return true;
      }
    }
    return false;      
  }

  getShortValue(full) {
    const value = this.getValue()
    let trueValues = 0;
    let shortValue = '';
    let separator = '';

    if (Array.isArray(value)) this.bs4Store.forEach((item) => {
      const checked = value.includes(item.id)
      if (checked) {
        trueValues++;
        shortValue += separator+item.name;
        separator = ', ';
      }
    });
    
    if (full) return shortValue;
    
    if (trueValues > 1) {
      return '('+trueValues+')';
    } 
    
    if (shortValue.length > 20) {
      return shortValue.substring(0, 17)+'...';
    }

    return shortValue;						
  }

  ViewSummaryDetails = (props) => {
    const formField = this;
    const theme = useTheme();
    const [value, setValue] = React.useState(() => this.getValue());

    const handleChange = (event, id) => {
      if (this.readOnly) return;
      const checked = value.includes(id)
      if (checked)  this.setValue(value.filter(v => v != id));
      else          this.setValue([...value, id]);
      this.reloadGridCriteria()
    };    

    React.useEffect(() => {
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        setValue(this.getValue());
      })    
    }, []);              
    
    return (      
      <React.Fragment>
        {formField.bs4Store.map(item => {
          const checked = value.includes(item.id)
          if (formField.readOnly && !checked) return null;
          return (                        
            <Chip 
              key={item.id} 
              label={item.name} 
              onClick={(event) => handleChange(event, item.id)}
              sx={{
                ...checked ? {color: '#000000', fontWeight: 'bold'} : {color: '#00000077'},
                ...checked ? {backgroundColor: '#00000022'} : {backgroundColor: '#0000000a'},
              }}
            />
          )
        })}    
      </React.Fragment>
    );
  }

  ViewComponentField = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(() => this.getValue());    
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)
    this.refFocus = React.useRef();
    const columns = this.isParamSelected('ATRYB_ONECOLUMN') ? 1 : 2
    
    const handleChange = (event) => {    
      if (formField.readOnly) return false;
      const newNalue = value.filter((v) => v != event.target.name);
      if (event.target.checked) newNalue.push(event.target.name);
      this.setValue(newNalue);
    };

    React.useEffect(() => {
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})}
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        setValue(this.getValue());
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      })    
    }, [error]);

    if (formField.readOnly) return (
      <FormControl
        id={this.props.field.inputId}
        fullWidth 
        error={error.error}
      >        
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}                    
        <Typography>{formField.getShortValue(true)}</Typography>
        <FormHelperText>{error.helperText}</FormHelperText>
      </FormControl>
    );
    
    // <FormControl fullWidth  error={error.error}>
    // {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
    // <RadioGroup value={value} onChange={handleChange}>
    //   <Box sx={{ flexGrow: 1 }}>
    //     <Grid container spacing={0.0} columns={{ xs: 1, sm: this.columns}}>

    else return (
      <FormControl fullWidth error={error.error}>
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <FormGroup>
          <Grid container spacing={0.0} columns={{ xs: 1, sm: columns }}>
            {this.bs4Store.map((item, index) => {
              const checked = value.includes(item.id)
              const refFocus = index === 0 ? { inputRef: this.refFocus } : {}
              return (
                <Grid item xs={1} key={item.id}>  
                  <FormControlLabel	
                    label={item.name}
                    control={<Checkbox checked={checked} onChange={handleChange} name={item.id} {...refFocus}/>}
                  />
                </Grid>
              )
            })}
          </Grid>
        </FormGroup>
        <FormHelperText>{error.helperText}</FormHelperText>
      </FormControl>
    );
  }
}